// The /pure entry: the default one injects the Stripe.js script tag as a
// side effect of being imported, which would load js.stripe.com for every
// visitor the moment any checkout host is bundled in — gate open or not.
import { loadStripe } from '@stripe/stripe-js/pure';

import { getStripePublishableKey } from './getEnv';

import type { Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * The one stripe.js instance the app mounts Elements with.
 *
 * A module singleton because `loadStripe` injects a script tag per call —
 * re-creating it remounts every Element and drops what the user typed. A
 * failed load is not cached, so leaving and reopening card entry retries.
 */
export const getStripeJs = (): Promise<Stripe | null> => {
  // The key read happens inside the chain so a missing key rejects instead
  // of throwing out of the caller's render — as an argument it would escape
  // the card entry error screen and unwind to the app-level error boundary.
  stripePromise ??= Promise.resolve()
    .then(() => loadStripe(getStripePublishableKey()))
    .catch((error: unknown) => {
      stripePromise = null;
      throw error;
    });
  return stripePromise;
};
